import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import cx from 'classnames';
import MaskedInput from 'react-text-mask';
import FormFooter from './FormFooter';
import FormLabel from './FormLabel';
import Icon from './Icon';
import { generateUUID } from '../helpers/utility';
import { config } from '../helpers/config';
var Input = React.forwardRef(function (_ref, ref) {
  var _cx;

  var className = _ref.className,
      label = _ref.label,
      guide = _ref.guide,
      mask = _ref.mask,
      name = _ref.name,
      onChange = _ref.onChange,
      type = _ref.type,
      validationMessage = _ref.validationMessage,
      explanationMessage = _ref.explanationMessage,
      prefixIcon = _ref.prefixIcon,
      required = _ref.required,
      opts = _objectWithoutPropertiesLoose(_ref, ["className", "label", "guide", "mask", "name", "onChange", "type", "validationMessage", "explanationMessage", "prefixIcon", "required"]);

  var id = name + "-" + generateUUID();

  var handleChange = function handleChange(_ref2) {
    var _ref2$target = _ref2.target,
        fieldName = _ref2$target.name,
        value = _ref2$target.value;
    onChange(fieldName, value);
  };

  var inputRender = function inputRender() {
    var defaultProps = Object.assign({
      id: id,
      className: 'form-input',
      name: name,
      type: type,
      onChange: handleChange,
      ref: ref
    }, opts); // `react-text-mask` does not support 'email' or 'number' input types

    if (mask && !['email', 'number'].includes(type)) {
      return React.createElement(MaskedInput, Object.assign({}, defaultProps, {
        mask: mask,
        guide: guide
      }));
    }

    return React.createElement("input", defaultProps);
  };

  var classes = cx('form-group', className, (_cx = {}, _cx[config.classes.notValid] = validationMessage, _cx[config.classes.required] = required, _cx));
  return React.createElement("div", {
    className: classes
  }, React.createElement(FormLabel, {
    id: id
  }, label), prefixIcon ? React.createElement("div", {
    className: "form-prefix-wrapper"
  }, React.createElement("div", {
    className: "form-prefix-content"
  }, React.createElement(Icon, {
    icon: prefixIcon
  })), inputRender()) : inputRender(), React.createElement(FormFooter, {
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }));
});
Input.defaultProps = {
  type: 'text',
  guide: false
};
export default Input;